import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles({
  root: {
    backgroundColor: ({ color }) => color,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "64px",
    height: "64px",
    borderRadius: "64px"
  },
  logoImg: {
    maxHeight: "64px"
  }
});

const ForceLogo = ({ src, alt, color }) => {
  const classes = useStyles({ color });

  return (
    <Box className={classes.root}>
      <img src={src} alt={alt} className={classes.logoImg} />
    </Box>
  );
};

ForceLogo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export default ForceLogo;
